import { IonButton, IonInput, IonItem } from '@ionic/react';
import { withTranslation } from '../../lib/translate.js';
import { sendVoucherCode, setCommonProp } from '../../store/actions.js';
import { connect } from 'react-redux';
import { Component } from 'react';
import './index.css';
import Modal from '../modal/index.js';
import { Spacer, StrongText } from '../common/index.js';



class VoucherCodeInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherCode: ''
    }
  }
  handlerOfVoucherCode = (e) => {
    const val = e.target.value.toUpperCase();
    this.setState({ voucherCode: val });
  };
  setVoucherCodeAlertVisible = (value) => {
    if (value) {
      this.setState({ voucherCode: '' });
    }
    this.props.dispatch(setCommonProp('voucherCodeAlertVisible', value));
  };
  sendCode = () => {
    const { dispatch } = this.props;
    const { voucherCode } = this.state;
    const data = { code: voucherCode.toUpperCase() };
    dispatch(sendVoucherCode(data, false));
  };

  render() {
    const { __, children, buttonText, showButton = false, disabled = false, voucherCodeAlertVisible } = this.props;
    const { voucherCode } = this.state;
    return (
      <>
        {showButton &&
          <>
            {!children ? <>
              <IonButton className="redeem-voucher-btn button-uppercase"
                onClick={() => {
                  this.setVoucherCodeAlertVisible(true);
                }}
                disabled={disabled}
                expand='block'
                color='secondary'

              >
                {buttonText ? __(buttonText) : __('Redeem voucher code')}
              </IonButton>
            </> : <div
              onClick={() => {
                !disabled && this.setVoucherCodeAlertVisible(true);
              }}
            >{children}</div>}
            <Modal onDidDismiss={() => this.setVoucherCodeAlertVisible(false)} isOpen={voucherCodeAlertVisible} className="modal-type-alert">
              <StrongText className='block text-to-update'>{__('Apply voucher code')}</StrongText>
              <Spacer size={5} />
              <div className="input-field-container">
                <IonItem className="input-field-wrapper" lines="none">
                  <IonInput
                    placeholder={__('Voucher code')}
                    onIonInput={(e) => this.handlerOfVoucherCode(e)}
                    value={voucherCode}
                  ></IonInput>
                </IonItem>
              </div>
              <div className='alert-button-group'>
                <IonButton
                  color="secondary"
                  expand="block"
                  onClick={() => this.setVoucherCodeAlertVisible(false)}
                  className="submit-button button-uppercase"
                >
                  {__('Cancel')}
                </IonButton>
                <IonButton
                  disabled={voucherCode === ''}
                  color="primary"
                  expand="block"
                  onClick={() => {
                    this.sendCode();
                  }}
                  className="submit-button button-uppercase"
                >
                  {__('Apply')}
                </IonButton>
              </div>

            </Modal>




          </>
        }
      </>
    );
  }
}

const stateToProps = (state) => {
  const { voucherCodeAlertVisible } = state.common;
  return {
    voucherCodeAlertVisible
  };
};

export default connect(stateToProps)(withTranslation(VoucherCodeInput));
